// Shared "Import from Shortcut" source-list loaders, moved verbatim from
// ModelQuickReply.vue and ShortcutMenu.vue (the two bodies were byte-identical)
// to remove duplicated code (SonarQube "Duplicated Lines") WITHOUT changing
// behavior. Both consumers declare `QuickGroup`, `loading`, `dialog`,
// `isSearch`, `isFirst`, `menus`, `searchName`, `totalTable`,
// `searchTotalTable` and `options` in data().
export default {
  methods: {
    GetDefault() {
      this.dialog = true;
      this.loading = true;
      const { page, itemsPerPage } = this.options;

      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchName,
        sortDesc: null,
        sortBy: null,
      };
      this.$call.GetTableModelQuickGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.QuickGroup = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
          } else {
            this.menus = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetQuickGroup() {
      this.$call.GetModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.QuickGroup = dataResponse.data.filter(
              (group) => group.isAllModel != true //NOSONAR
            );
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
  },
};
